// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
// 图表界面
import statistics from '@/views/charts/statistics';




/**
 * 用户管理
 */
//用户列表
import userList from '@/views/user/userList';





/**
 * 展会管理
 */
//展会列表
import medalList from '@/views/platform/medalList';
//展会预约管理
import platform from '@/views/platform/platform';
import stadium from '@/views/platform/stadium';





/**
 * 商品中心
 */
//分类管理
import playgroundList from '@/views/lottery/playgroundList';
//商品管理
import signInLogList from '@/views/lottery/signInLogList';
//商品编辑
import commodityEdit from '@/views/lottery/commodityEdit';







/**
 * 订单管理
 */
// 订单列表
import orderList from '@/views/convenience/orderList';
// 订单详情
import orderDetail from '@/views/convenience/orderDetail';
// 商品列表
import productList from '@/views/convenience/productList';
// 退款查验详情
import refundDetail from '@/views/convenience/refundDetail';
// 押金退款管理
import cashList from '@/views/convenience/cashList';
// 财务复核管理
import fhList from '@/views/convenience/fhList';




/**
 * 大型设备管理
 */
//大型设备管理
import questionTopicList from '@/views/exam/questionTopicList';



/**
 * banner配置
 */
//banner管理
import activityRankingList from '@/views/ranking/activityRankingList';




/**
 * 系统设置
 * */
//账号管理
import sysUser from '@/views/system/user';
//角色管理
import sysRole from '@/views/system/Role';
//菜单管理
import sysMenu from '@/views/system/menu';
//系统参数配置
import program from '@/views/system/program';
//操作日志
import systemLogList from '@/views/system/systemLogList';




// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    // mode: "history",
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '/login',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    },
      {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/charts/statistics',
            name: '数据统计',
            component: statistics,
            meta: {
                requireAuth: true
            }
        },{
          path: '/user/userList',
          name: '用户列表',
          component: userList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/platform/medalList',
          name: '展会管理',
          component: medalList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/platform/platform',
          name: '展会预约管理',
          component: platform,
          meta: {
            requireAuth: true
          }
        },{
          path: '/platform/stadium',
          name: '场馆配置',
          component: stadium,
          meta: {
            requireAuth: true
          }
        },{
          path: '/lottery/playgroundList',
          name: '分类管理',
          component: playgroundList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/lottery/signInLogList',
          name: '商品管理',
          component: signInLogList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/lottery/commodityEdit',
          name: '商品编辑',
          component: commodityEdit,
          meta: {
            requireAuth: true
          }
        },{
          path: '/convenience/orderList',
          name: '订单管理',
          component: orderList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/convenience/orderDetail',
          name: '订单详情',
          component: orderDetail,
          meta: {
            requireAuth: true
          }
        },{
          path: '/convenience/productList',
          name: '查验中心',
          component: productList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/convenience/refundDetail',
          name: '退款查验详情',
          component: refundDetail,
          meta: {
            requireAuth: true
          }
        },{
          path: '/convenience/cashList',
          name: '押金退款管理',
          component: cashList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/convenience/fhList',
          name: '财务复核管理',
          component: fhList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/exam/questionTopicList',
          name: '大型设备进场管理',
          component: questionTopicList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/ranking/activityRankingList',
          name: 'banner管理',
          component: activityRankingList,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/user',
          name: '账号管理',
          component: sysUser,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/menu',
          name: '菜单管理',
          component: sysMenu,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/Role',
          name: '角色管理',
          component: sysRole,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/program',
          name: '系统参数配置',
          component: program,
          meta: {
            requireAuth: true
          }
        },{
          path: '/system/systemLogList',
          name: '操作日志',
          component: systemLogList,
          meta: {
            requireAuth: true
          }
        }]
    }]
})

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}







// WEBPACK FOOTER //
// ./src/router/index.js